export default __webpack_public_path__ + "static/media/broccolini-honey-soy.40953656.png";